import { apiClient } from "@/config/api";
import {
  CacheType,
  CacheStatsResponse,
  ClearCacheByTypeResponse,
  ClientCacheType,
  ClientRevalidationResult,
  ClearAndRevalidateResult,
  ClientHealthResponse,
} from "@/types/cache";

class CacheService {
  // ==================== STATISTICS ====================

  /**
   * Lấy thống kê cache theo loại
   */
  async getCacheStats(): Promise<{ data: CacheStatsResponse }> {
    const response = await apiClient.get("/cache/stats");

    if (!response.ok) {
      throw new Error(response.data?.message || "Lỗi khi lấy thống kê cache");
    }

    return response.data;
  }

  /**
   * Kiểm tra client health
   */
  async checkClientHealth(): Promise<{ data: ClientHealthResponse }> {
    const response = await apiClient.get("/cache/client-health");

    if (!response.ok) {
      throw new Error(response.data?.message || "Lỗi khi kiểm tra client");
    }

    return response.data;
  }

  // ==================== CLEAR API CACHE ====================

  /**
   * Xóa toàn bộ cache API (Redis)
   */
  async clearAllCache(): Promise<ClearCacheByTypeResponse> {
    const response = await apiClient.delete("/cache/clear-all");

    if (!response.ok) {
      throw new Error(response.data?.message || "Lỗi khi xóa cache");
    }

    return response.data;
  }

  /**
   * Xóa cache theo loại
   */
  async clearCacheByType(type: CacheType): Promise<ClearCacheByTypeResponse> {
    const response = await apiClient.delete(`/cache/clear/${type}`);

    if (!response.ok) {
      throw new Error(response.data?.message || "Lỗi khi xóa cache");
    }

    return response.data;
  }

  // ==================== CLIENT REVALIDATION ====================

  /**
   * Revalidate client cache theo type
   */
  async revalidateClient(
    type: ClientCacheType,
    slug?: string,
    episodeSlug?: string
  ): Promise<ClientRevalidationResult> {
    const response = await apiClient.post("/cache/revalidate-client", {
      type,
      slug,
      episodeSlug,
    });

    if (!response.ok) {
      throw new Error(response.data?.message || "Lỗi khi revalidate client");
    }

    return response.data;
  }

  /**
   * Revalidate toàn bộ client cache
   */
  async revalidateAllClient(): Promise<ClientRevalidationResult> {
    const response = await apiClient.post("/cache/revalidate-client/all");

    if (!response.ok) {
      throw new Error(response.data?.message || "Lỗi khi revalidate client");
    }

    return response.data;
  }

  // ==================== COMBINED OPERATIONS ====================

  /**
   * Xóa cache API và revalidate client
   */
  async clearAndRevalidate(
    type: CacheType,
    revalidatePaths?: string[]
  ): Promise<ClearAndRevalidateResult> {
    const response = await apiClient.post("/cache/clear-and-revalidate", {
      type,
      revalidatePaths,
    });

    if (!response.ok) {
      throw new Error(response.data?.message || "Lỗi khi xóa và revalidate");
    }

    return response.data;
  }

  /**
   * Xóa toàn bộ cache API và revalidate toàn bộ client
   */
  async clearAllAndRevalidate(): Promise<ClearAndRevalidateResult> {
    const response = await apiClient.post("/cache/clear-all-and-revalidate");

    if (!response.ok) {
      throw new Error(response.data?.message || "Lỗi khi xóa và revalidate");
    }

    return response.data;
  }
}

export const cacheService = new CacheService();
